import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { PageSection, SectionHeader, SectionSubTitle, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { Fragment, memo } from 'react';
import { getLocalizedImages } from './getLocalizedImages';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const generateGridTemplateAreas = rows => {
  let areas = '';
  for (let i = 0; i < rows; i++) {
    if (i % 2 === 0) {
      areas += `"img-${i} text-${i}"\n`;
    } else {
      areas += `"text-${i} img-${i}"\n`;
    }
  }
  return areas.trim();
};
const Grid = styled.div.withConfig({
  displayName: "KeyFeatures__Grid",
  componentId: "u73jw7-0"
})(({
  rows,
  theme
}) => {
  return {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateAreas: generateGridTemplateAreas(rows),
    rowGap: theme.space[700],
    columnGap: theme.space[1300],
    alignItems: 'center',
    justifyItems: 'center',
    [trellisBreakpoint.sdMac]: {
      columnGap: theme.space[700]
    },
    [trellisBreakpoint.tablet]: {
      display: 'flex',
      flexDirection: 'column',
      columnGap: theme.space[0]
    }
  };
});
const KeyFeatures = ({
  features
}) => {
  return /*#__PURE__*/_jsxs(PageSection, {
    hideOverflow: false,
    children: [/*#__PURE__*/_jsxs(SectionHeader, {
      maxInlineSize: "100%",
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.breezeIntelligence.keyFeatures.title"
        })
      }), /*#__PURE__*/_jsx(SectionSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.breezeIntelligence.keyFeatures.description"
        })
      })]
    }), /*#__PURE__*/_jsx(Grid, {
      rows: features.length,
      children: features.map((feature, index) => {
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(PPUIGridItem, {
            gridArea: `img-${index}`,
            children: /*#__PURE__*/_jsx(View, {
              boxShadow: "300",
              marginBlock: "1100",
              children: /*#__PURE__*/_jsx(Image, {
                src: getLocalizedImages(feature),
                inlineSize: "450px"
              })
            })
          }), /*#__PURE__*/_jsxs(PPUIGridItem, {
            gridArea: `text-${index}`,
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h3",
              typography: "heading-300",
              marginBlockEnd: "400",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `pricingPage.pages.breezeIntelligence.keyFeatures.features.${feature}.title`
              })
            }), /*#__PURE__*/_jsx(Text, {
              as: "p",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `pricingPage.pages.breezeIntelligence.keyFeatures.features.${feature}.description`
              })
            })]
          })]
        }, feature);
      })
    })]
  });
};
export default /*#__PURE__*/memo(KeyFeatures);